import React, { useState, useEffect } from 'react';
import { apprenantsAPI, configAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import FormInput from '../components/FormInput';
import FormSelect from '../components/FormSelect';
import Modal from '../components/Modal';
import * as XLSX from 'xlsx';
import api from '../services/api';
import Icon from '../components/Icon';

// Champs de l'import en masse : le nom est toujours obligatoire, tout le reste est au choix
const IMPORT_FILE_FIELDS = [
  { key: 'prenom', label: 'Prénom', header: 'Prénom', example: 'Awa' },
  { key: 'genre', label: 'Genre', header: 'Genre', example: 'Femme' },
  { key: 'age', label: 'Âge', header: 'Age', example: 22 },
  { key: 'telephone', label: 'Téléphone', header: 'Telephone', example: '0102030405' },
  { key: 'email', label: 'Email', header: 'Email', example: 'awa.kone@exemple.ci' },
  { key: 'abandon', label: 'Abandon', header: 'Abandon', example: 'Non' },
  { key: 'estDiplome', label: 'Diplômé', header: 'Diplôme obtenu', example: 'Oui' }
];
const IMPORT_FORM_FIELDS = [
  { key: 'typeFormation', label: 'Type de formation' },
  { key: 'filiere', label: 'Référentiel' },
  { key: 'anneeFormation', label: 'Année de formation' },
  { key: 'dureeFormation', label: 'Durée de formation' },
  { key: 'dateDebut', label: 'Date début' },
  { key: 'dateFin', label: 'Date fin' },
  { key: 'promotion', label: 'Promotion' }
];

// Mise à jour insertion : le nom est toujours obligatoire, le reste est au choix
const INSERTION_ID_FIELDS = [
  { key: 'email', label: 'Email', header: 'Email', example: 'awa.kone@exemple.ci' },
  { key: 'telephone', label: 'Téléphone', header: 'Téléphone', example: '0102030405' },
  { key: 'prenom', label: 'Prénom (facultatif)', header: 'Prénom', example: 'Awa' }
];
const INSERTION_UPDATE_FIELDS = [
  { key: 'entreprise', label: 'Entreprise', header: 'Entreprise', example: 'Orange CI' },
  { key: 'poste', label: 'Poste', header: 'Poste', example: 'Développeuse web' },
  { key: 'typeContrat', label: 'Type contrat', header: 'Type contrat', example: 'CDI' },
  { key: 'salaire', label: 'Salaire', header: 'Salaire', example: 350000 },
  { key: 'salaireTranche', label: 'Tranche salariale', header: 'Tranche salariale', example: '300 000 - 500 000 FCFA' },
  { key: 'dateInsertion', label: 'Date insertion', header: 'Date insertion', example: '15/03/2026' },
  { key: 'dateDebutContrat', label: 'Date début contrat', header: 'Date début contrat', example: '01/04/2026' },
  { key: 'statutInsertion', label: 'Statut insertion', header: 'Statut insertion', example: 'Inséré' },
  { key: 'situationSortie', label: 'Situation sortie', header: 'Situation sortie', example: 'En emploi' }
];
const ALL_INSERTION_FIELDS = [...INSERTION_ID_FIELDS, ...INSERTION_UPDATE_FIELDS];

const Saisie = () => {
  const { isFormateur } = useAuth();
  const [formData, setFormData] = useState({
    matricule: '',
    nom: '',
    prenom: '',
    genre: '',
    dateNaissance: '',
    age: '',
    telephone: '',
    email: '',
    ville: '',
    region: '',
    diplome: '',
    statutEntree: '',
    typeFormation: '',
    filiere: '',
    formateur: '',
    dateDebut: '',
    dateFin: '',
    anneeFormation: '',
    dureeFormation: '',
    promotion: '',
    statutFormation: '',
    abandon: false,
    estDiplome: false,
    assiduite: '',
    statutInsertion: '',
    dateInsertion: '',
    situationSortie: '',
    situationM3: '',
    situationM6: '',
    typeContrat: '',
    entreprise: '',
    poste: '',
    dateDebutContrat: '',
    remuneration: '',
    salaireTranche: '',
    notes: '',
    referent: '',
    derniereDateContact: '',
    etatDossier: ''
  });
  const [config, setConfig] = useState(null);
  const [salaireMode, setSalaireMode] = useState('exact');
  const [showInsertion, setShowInsertion] = useState(true);
  const [showInsertionFields, setShowInsertionFields] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [addModalType, setAddModalType] = useState('');
  const [addModalValue, setAddModalValue] = useState('');
  const [addModalCategory, setAddModalCategory] = useState('positif');
  const [showImportModal, setShowImportModal] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importPreview, setImportPreview] = useState([]);
  const [importData, setImportData] = useState(null);
  const [importForm, setImportForm] = useState({
    typeFormation: '',
    filiere: '',
    dateDebut: '',
    dateFin: '',
    anneeFormation: '',
    dureeFormation: '',
    promotion: ''
  });
  const [importLoading, setImportLoading] = useState(false);
  const [importFields, setImportFields] = useState(IMPORT_FILE_FIELDS.map(f => f.key));

  const toggleImportField = (key) => {
    setImportFields(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]);
  };
  const selectedFileFields = IMPORT_FILE_FIELDS.filter(f => importFields.includes(f.key));

  // Mise à jour en masse des données d'insertion
  const [showInsertionModal, setShowInsertionModal] = useState(false);
  const [insertionFile, setInsertionFile] = useState(null);
  const [insertionResult, setInsertionResult] = useState(null);
  const [insertionLoading, setInsertionLoading] = useState(false);
  const [insertionFields, setInsertionFields] = useState(ALL_INSERTION_FIELDS.map(f => f.key));
  const selectedInsertionFields = ALL_INSERTION_FIELDS.filter(f => insertionFields.includes(f.key));

  const toggleInsertionField = (key) => {
    if ((key === 'email' || key === 'telephone') && insertionFields.includes(key)) {
      const other = key === 'email' ? 'telephone' : 'email';
      if (!insertionFields.includes(other)) {
        toast.info("L'email ou le téléphone est obligatoire en plus du nom");
        return;
      }
    }
    const next = insertionFields.includes(key)
      ? insertionFields.filter(k => k !== key)
      : [...insertionFields, key];
    setInsertionFields(next);
    // l'aperçu se recalcule automatiquement avec la nouvelle sélection
    if (insertionFile && insertionResult?.dryRun) sendInsertionFile(true, insertionFile, next);
  };

  const closeInsertionModal = () => {
    setShowInsertionModal(false);
    setInsertionFile(null);
    setInsertionResult(null);
  };

  const sendInsertionFile = async (dryRun, file = insertionFile, fields = insertionFields) => {
    if (!file) {
      toast.error('Veuillez sélectionner un fichier');
      return;
    }
    setInsertionLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('dryRun', dryRun ? 'true' : 'false');
      formData.append('fields', JSON.stringify(fields));
      const response = await api.post('/apprenants/import-insertion', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setInsertionResult(response.data);
      if (!dryRun) {
        toast.success(response.data.message);
        setInsertionFile(null);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Erreur lors de la mise à jour');
    } finally {
      setInsertionLoading(false);
    }
  };

  const downloadImportTemplate = () => {
    const headers = ['Nom', ...selectedFileFields.map(f => f.header)];
    const ws = XLSX.utils.aoa_to_sheet([
      headers,
      ['Koné', ...selectedFileFields.map(f => f.example)],
      ['Traoré', ...selectedFileFields.map(() => '')]
    ]);
    ws['!cols'] = headers.map(() => ({ wch: 20 }));
    const wsNotes = XLSX.utils.aoa_to_sheet([
      ["Import en masse des apprenants - mode d'emploi"],
      [],
      ['Nom', 'Obligatoire.'],
      ['Autres colonnes', "Facultatives : laissez vide si l'information est indisponible (KIDS, master class...)."],
      ['Genre', 'Homme / Femme (M, F, H acceptés).'],
      ['Informations de formation', "Cochées dans le formulaire de l'import (type, référentiel, année, durée, dates, promotion) : elles s'appliquent à toutes les lignes."],
      ["Lignes d'exemple", "Supprimez les lignes 2 et 3 avant l'import."]
    ]);
    wsNotes['!cols'] = [{ wch: 30 }, { wch: 90 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Apprenants');
    XLSX.utils.book_append_sheet(wb, wsNotes, 'Instructions');
    XLSX.writeFile(wb, 'modele_import_apprenants.xlsx');
  };

  const downloadInsertionTemplate = () => {
    const headers = ['Nom', ...selectedInsertionFields.map(f => f.header)];
    const example = ['Koné', ...selectedInsertionFields.map(f => f.example)];
    const ws = XLSX.utils.aoa_to_sheet([headers, example]);
    ws['!cols'] = headers.map(h => ({ wch: Math.max(h.length + 4, 18) }));

    const wsNotes = XLSX.utils.aoa_to_sheet([
      ["Mise à jour en masse des données d'insertion - mode d'emploi"],
      [],
      ['Nom', 'Obligatoire.'],
      ['Email ou Téléphone', "Obligatoire (au moins l'un des deux) : permet d'identifier l'apprenant (Email prioritaire)."],
      ['Prénom', 'Facultatif : aide à départager des homonymes.'],
      ['Autres colonnes', 'Facultatives. Cellules vides ignorées : les données existantes ne sont pas écrasées.'],
      ['Dates', 'Format jj/mm/aaaa (ex : 15/03/2026).'],
      ['Salaire', 'Nombre seul, en FCFA (ex : 350000).'],
      ['Statut insertion', 'Ex : Inséré, Auto-entrepreneur, Freelance, Poursuite Formation, En recherche. Si vide et Entreprise renseignée : « Inséré ».'],
      ['Type contrat', 'CDI, CDD, Stage, Freelance, Alternance, Intérim, Consultant'],
      ['Tranche salariale', 'Moins de 100 000 FCFA / 100 000 - 200 000 FCFA / 200 000 - 300 000 FCFA / 300 000 - 500 000 FCFA / Plus de 500 000 FCFA'],
      ['Situation sortie', 'En recherche, En emploi, En formation, Inactif'],
      ["Ligne d'exemple", "Supprimez la 2e ligne de l'onglet « Insertion » avant l'import."]
    ]);
    wsNotes['!cols'] = [{ wch: 30 }, { wch: 110 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Insertion');
    XLSX.utils.book_append_sheet(wb, wsNotes, 'Instructions');
    XLSX.writeFile(wb, 'modele_mise_a_jour_insertion.xlsx');
  };

  useEffect(() => {
    fetchConfig();
    const tomorrow = new Date();
    tomorrow.setMonth(tomorrow.getMonth() + 3);
    setFormData(prev => ({
      ...prev,
      dateFin: ''
    }));
  }, []);

  useEffect(() => {
    const typeLower = formData.typeFormation?.toLowerCase() || '';
    const isAcculturation = typeLower.includes('acculturation') || typeLower.includes('bootcamp');
    setShowInsertion(!isAcculturation);
    if (isAcculturation) {
      // Acculturation / Bootcamp : pas d'insertion ni de suivi administratif
      setFormData(prev => ({ ...prev, statutInsertion: 'N/A', referent: '', derniereDateContact: '', etatDossier: '' }));
    }
  }, [formData.typeFormation]);

  useEffect(() => {
    const positiveStatuses = ['Inséré', 'Auto-entrepreneur', 'Freelance'];
    setShowInsertionFields(positiveStatuses.includes(formData.statutInsertion));
  }, [formData.statutInsertion]);

  const fetchConfig = async () => {
    try {
      const response = await configAPI.get();
      setConfig(response.data);
    } catch (error) {
      toast.error('Erreur lors du chargement de la configuration');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // If user edits date of birth, compute age automatically
    if (name === 'dateNaissance') {
      let computedAge = '';
      if (value) {
        const dob = new Date(value);
        const now = new Date();
        let ageYears = now.getFullYear() - dob.getFullYear();
        const m = now.getMonth() - dob.getMonth();
        if (m < 0 || (m === 0 && now.getDate() < dob.getDate())) {
          ageYears--;
        }
        computedAge = ageYears >= 0 ? String(ageYears) : '';
      }
      setFormData(prev => ({ ...prev, dateNaissance: value, age: computedAge }));
      return;
    }

    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormateur) {
      toast.error('Pas de droits');
      return;
    }

    setLoading(true);
    try {
      const dataToSend = {
        ...formData,
        age: formData.age ? parseInt(formData.age) : null,
        assiduite: formData.assiduite ? parseFloat(formData.assiduite) : null,
        salaire: salaireMode === 'exact' ? (formData.salaire ? parseInt(formData.salaire) : null) : null,
        salaireTranche: salaireMode === 'tranche' ? formData.salaireTranche : null,
        dateNaissance: formData.dateNaissance || null,
        dateInsertion: formData.dateInsertion || null,
        dateDebutContrat: formData.dateDebutContrat || null,
        derniereDateContact: formData.derniereDateContact || null
      };

      await apprenantsAPI.create(dataToSend);
      toast.success('Apprenant enregistré !');
      resetForm();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Erreur lors de l\'enregistrement');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    const tomorrow = new Date();
    tomorrow.setMonth(tomorrow.getMonth() + 3);
    setFormData({
      matricule: '',
      nom: '',
      prenom: '',
      genre: '',
      dateNaissance: '',
      age: '',
      telephone: '',
      email: '',
      ville: '',
      region: '',
      diplome: '',
      statutEntree: '',
      typeFormation: '',
      filiere: '',
      formateur: '',
      dateDebut: new Date().toISOString().split('T')[0],
      dateFin: tomorrow.toISOString().split('T')[0],
      anneeFormation: '',
      dureeFormation: '',
      promotion: '',
      statutFormation: '',
      abandon: false,
      estDiplome: false,
      assiduite: '',
      statutInsertion: '',
      dateInsertion: '',
      situationSortie: '',
      situationM3: '',
      situationM6: '',
      typeContrat: '',
      entreprise: '',
      poste: '',
      dateDebutContrat: '',
      remuneration: '',
      salaire: '',
      salaireTranche: '',
      notes: '',
      referent: '',
      derniereDateContact: '',
      etatDossier: ''
    });
    setSalaireMode('exact');
    setShowInsertionFields(false);
  };

  const openAddModal = (type, category = '') => {
    setAddModalType(type);
    setAddModalCategory(category);
    setAddModalValue('');
    setShowAddModal(true);
  };

  const handleAddItem = async () => {
    if (!addModalValue.trim()) {
      toast.error('Valeur requise');
      return;
    }

    try {
      await configAPI.addItem(addModalType, addModalValue.trim(), addModalCategory);
      await fetchConfig();
      setShowAddModal(false);
      toast.success('Élément ajouté !');
    } catch (error) {
      toast.error('Erreur lors de l\'ajout');
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImportFile(file);

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        let data = [];
        if (file.name.endsWith('.csv')) {
          const content = e.target.result;
          const lines = content.split('\n').filter(l => l.trim());
          if (lines.length === 0) return;

          const separator = lines[0].includes(';') ? ';' : ',';
          const headers = lines[0].split(separator).map(h => h.trim().toLowerCase());

          for (let i = 1; i < lines.length; i++) {
            const values = lines[i].split(separator);
            const row = {};
            headers.forEach((header, idx) => {
              row[header] = (values[idx] || '').trim();
            });
            if (row.nom || row.Nom || row.NOM) {
              data.push({
                nom: row.nom || row.Nom || row.NOM || '',
                prenom: row.prenom || row.Prenom || row.PRÉNOM || row.prénom || row.Prénom || '',
                genre: row.genre || row.Genre || row.sexe || row.Sexe || '',
                age: parseInt(row.age || row.Age || row.AGE || 0) || null,
                telephone: row.telephone || row.Telephone || row.tel || row.Tel || '',
                email: row.email || row.Email || row.EMAIL || row.mail || row.Mail || '',
                abandon: row.abandon || '',
                estDiplome: row['diplôme obtenu'] || row['diplome obtenu'] || row.diplômé || row.diplomé || row.diplome || ''
              });
            }
          }
        } else {
          const wb = XLSX.read(e.target.result, { type: 'binary' });
          const jsonData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
          data = jsonData.map(r => ({
            nom: r.Nom || r.nom || r.NOM || '',
            prenom: r.Prenom || r.prenom || r.Prénom || r.PRÉNOM || '',
            genre: r.Genre || r.genre || r.Sexe || r.sexe || '',
            age: parseInt(r.Age || r.age || r.AGE || 0) || null,
            telephone: r.Telephone || r.telephone || r.Tel || r.tel || '',
            email: r.Email || r.email || r.EMAIL || r.Mail || r.mail || '',
            abandon: r.Abandon || r.abandon || '',
            estDiplome: r['Diplôme obtenu'] || r['Diplome obtenu'] || r.Diplômé || r.Diplomé || r.Diplome || ''
          })).filter(r => r.nom);
        }
        setImportData(data);
        setImportPreview(data.slice(0, 10));
      } catch (err) {
        toast.error('Erreur lors de la lecture du fichier: ' + err.message);
      }
    };

    if (file.name.endsWith('.csv')) {
      reader.readAsText(file);
    } else {
      reader.readAsBinaryString(file);
    }
  };

  const handleImport = async () => {
    if (!importFile || !importData || importData.length === 0) {
      toast.error('Veuillez sélectionner un fichier');
      return;
    }

    setImportLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', importFile);
      IMPORT_FORM_FIELDS.forEach(({ key }) => {
        if (importFields.includes(key) && importForm[key]) {
          formData.append(key, importForm[key]);
        }
      });
      formData.append('fields', JSON.stringify(selectedFileFields.map(f => f.key)));

      const response = await api.post('/apprenants/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.rejected?.length) {
        const details = response.data.rejected.slice(0, 3).map(r => `ligne ${r.ligne} (${r.nom})`).join(', ');
        toast.warn(`${response.data.count} importé(s), ${response.data.rejected.length} ignoré(s) : ${details}`);
      } else {
        toast.success(`${response.data.count} apprenant(s) importé(s) !`);
      }
      setShowImportModal(false);
      setImportFile(null);
      setImportData(null);
      setImportPreview([]);
      setImportForm({
        typeFormation: '',
        filiere: '',
        dateDebut: '',
        dateFin: '',
        anneeFormation: '',
        dureeFormation: '',
        promotion: ''
      });
    } catch (error) {
      toast.error(error.response?.data?.message || 'Erreur lors de l\'import');
    } finally {
      setImportLoading(false);
    }
  };

  if (!config) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold flex items-center">
          <Icon name="edit" size={24} className="mr-2" />
          Saisie
        </h2>
        <div className="flex gap-2">
          <button
            onClick={() => setShowInsertionModal(true)}
            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
          >
            💼 MAJ Insertion en Masse
          </button>
          <button
            onClick={() => setShowImportModal(true)}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            📤 Import en Masse
          </button>
        </div>
      </div>

      <div className="section-card bg-white rounded-xl p-6">
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Informations Personnelles */}
          <div className="border-l-4 border-red-600 pl-4 bg-red-50 rounded-r-lg py-4 pr-4">
            <h3 className="font-bold text-red-800 mb-4 flex items-center">
              <Icon name="user" size={20} className="mr-2" />
              Informations Personnelles
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <FormInput
                label="ID Apprenant (Matricule)"
                name="matricule"
                value={formData.matricule}
                onChange={handleChange}
                placeholder="Ex: ID2025-0001"
              />

              <FormInput
                label="Nom"
                name="nom"
                value={formData.nom}
                onChange={handleChange}
                required
              />
              <FormInput
                label="Prénom"
                name="prenom"
                value={formData.prenom}
                onChange={handleChange}
              />
              <FormSelect
                label="Genre"
                name="genre"
                value={formData.genre}
                onChange={handleChange}
                required
                options={['Homme', 'Femme']}
              />
              <FormInput
                label="Date de naissance"
                name="dateNaissance"
                type="date"
                value={formData.dateNaissance}
                onChange={handleChange}
              />
              <div>
                <label htmlFor="saisie-age" className="block text-sm font-medium mb-1">Âge</label>
                <input
                  id="saisie-age"
                  name="age"
                  type="number"
                  min="15"
                  max="70"
                  value={formData.age}
                  onChange={handleChange}
                  readOnly={!!formData.dateNaissance}
                  disabled={!!formData.dateNaissance}
                  className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 ${formData.dateNaissance ? 'bg-gray-100 cursor-not-allowed' : ''
                    }`}
                  title={formData.dateNaissance ? "Calculé automatiquement à partir de la date de naissance" : ""}
                  autoComplete="off"
                />
                {formData.dateNaissance && (
                  <p className="mt-1 text-xs text-gray-500">Calculé automatiquement</p>
                )}
              </div>
              <FormInput
                label="Téléphone"
                name="telephone"
                type="tel"
                value={formData.telephone}
                onChange={handleChange}
              />
              <FormInput
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
              />
              <FormInput
                label="Ville"
                name="ville"
                value={formData.ville}
                onChange={handleChange}
              />
              <FormInput
                label="Région"
                name="region"
                value={formData.region}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Profil Entrée */}
          <div className="border-l-4 border-purple-600 pl-4 bg-purple-50 rounded-r-lg py-4 pr-4">
            <h3 className="font-bold text-purple-800 mb-4 flex items-center">
              <Icon name="document" size={20} className="mr-2" />
              Profil Entrée
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <FormSelect
                label="Niveau d'étude"
                name="diplome"
                value={formData.diplome}
                onChange={handleChange}
                options={config.diplomes || []}
                onAddNew={() => openAddModal('diplomes')}
                addLabel="+"
              />
              <FormSelect
                label="Statut entrée"
                name="statutEntree"
                value={formData.statutEntree}
                onChange={handleChange}
                required
                options={config.statutsEntree || []}
                onAddNew={() => openAddModal('statutsEntree')}
                addLabel="+"
              />
            </div>
          </div>

          {/* Formation */}
          <div className="border-l-4 border-blue-600 pl-4 bg-blue-50 rounded-r-lg py-4 pr-4">
            <h3 className="font-bold text-blue-800 mb-4 flex items-center">
              <Icon name="book" size={20} className="mr-2" />
              Formation
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <FormSelect
                label="Type"
                name="typeFormation"
                value={formData.typeFormation}
                onChange={handleChange}
                required
                options={config.typesFormation || []}
                onAddNew={() => openAddModal('typesFormation')}
                addLabel="+"
              />
              <FormSelect
                label="Referentiel"
                name="filiere"
                value={formData.filiere}
                onChange={handleChange}
                required
                options={config.filieres || []}
                onAddNew={() => openAddModal('filieres')}
                addLabel="+"
              />
              <FormInput
                label="Formateur"
                name="formateur"
                value={formData.formateur}
                onChange={handleChange}
              />
              <FormInput
                label="Date début"
                name="dateDebut"
                type="date"
                value={formData.dateDebut}
                onChange={handleChange}
              />
              <FormInput
                label="Date fin"
                name="dateFin"
                type="date"
                value={formData.dateFin}
                onChange={handleChange}
              />
              <FormInput
                label="Année de formation"
                name="anneeFormation"
                value={formData.anneeFormation}
                onChange={handleChange}
                placeholder="Ex: 2025"
                required
              />
              <FormInput
                label="Durée de formation"
                name="dureeFormation"
                value={formData.dureeFormation}
                onChange={handleChange}
                placeholder="Ex: 3 mois"
                required
              />
              <FormSelect
                label="Promotion"
                name="promotion"
                value={formData.promotion}
                onChange={handleChange}
                options={config.promotions || []}
                onAddNew={() => openAddModal('promotions')}
                addLabel="+"
              />
              <FormSelect
                label="Statut Formation"
                name="statutFormation"
                value={formData.statutFormation}
                onChange={handleChange}
                options={config.statutsFormation || ['En cours', 'Validé', 'Abandon', 'Échec']}
                onAddNew={() => openAddModal('statutsFormation')}
                addLabel="+"
              />
              <FormInput
                label="Assiduité / Présence (%)"
                name="assiduite"
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={formData.assiduite}
                onChange={handleChange}
                placeholder="Ex: 85.5"
              />
              <div className="flex flex-col justify-center gap-2">
                <label htmlFor="abandon" className="flex items-center gap-2 text-sm cursor-pointer">
                  <input
                    id="abandon"
                    name="abandon"
                    type="checkbox"
                    checked={!!formData.abandon}
                    onChange={(e) => setFormData(prev => ({
                      ...prev,
                      abandon: e.target.checked,
                      ...(e.target.checked ? { estDiplome: false } : {})
                    }))}
                  />
                  Abandon (a quitté la formation)
                </label>
                <label htmlFor="estDiplome" className="flex items-center gap-2 text-sm cursor-pointer">
                  <input
                    id="estDiplome"
                    name="estDiplome"
                    type="checkbox"
                    checked={!!formData.estDiplome}
                    onChange={(e) => setFormData(prev => ({
                      ...prev,
                      estDiplome: e.target.checked,
                      ...(e.target.checked ? { abandon: false } : {})
                    }))}
                  />
                  Diplômé (formation terminée, diplôme obtenu)
                </label>
              </div>
            </div>
          </div>

          {/* Insertion Professionnelle */}
          {showInsertion && (
            <div className="border-l-4 border-green-600 pl-4 bg-green-50 rounded-r-lg py-4 pr-4">
              <h3 className="font-bold text-green-800 mb-4 flex items-center">
                <Icon name="briefcase" size={20} className="mr-2" />
                Insertion Professionnelle
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <FormSelect
                  label="Situation à la sortie"
                  name="situationSortie"
                  value={formData.situationSortie}
                  onChange={handleChange}
                  options={config.situationsSortie || ['En recherche', 'En emploi', 'En formation', 'Inactif']}
                  onAddNew={() => openAddModal('situationsSortie')}
                  addLabel="+"
                />
                <FormSelect
                  label="Situation à M+3"
                  name="situationM3"
                  value={formData.situationM3}
                  onChange={handleChange}
                  options={config.situationsSortie || ['En recherche', 'En emploi', 'En formation', 'Inactif']}
                  onAddNew={() => openAddModal('situationsSortie')}
                  addLabel="+"
                />
                <FormSelect
                  label="Situation à M+6"
                  name="situationM6"
                  value={formData.situationM6}
                  onChange={handleChange}
                  options={config.situationsSortie || ['En recherche', 'En emploi', 'En formation', 'Inactif']}
                  onAddNew={() => openAddModal('situationsSortie')}
                  addLabel="+"
                />
                <div>
                  <FormSelect
                    label="Statut"
                    name="statutInsertion"
                    value={formData.statutInsertion}
                    onChange={handleChange}
                    options={[
                      ...(config.statutsInsertion?.positif || []).map(s => ({ value: s, label: `✅ ${s}` })),
                      ...(config.statutsInsertion?.negatif || []).map(s => ({ value: s, label: `❌ ${s}` }))
                    ]}
                    onAddNew={() => openAddModal('statutsInsertion')}
                    addLabel="+"
                  />
                </div>
                {showInsertionFields && (
                  <>
                    <FormInput
                      label="Date insertion"
                      name="dateInsertion"
                      type="date"
                      value={formData.dateInsertion}
                      onChange={handleChange}
                    />
                    <FormSelect
                      label="Type contrat"
                      name="typeContrat"
                      value={formData.typeContrat}
                      onChange={handleChange}
                      options={config.typesContrat || []}
                      onAddNew={() => openAddModal('typesContrat')}
                      addLabel="+"
                    />
                    <FormInput
                      label="Entreprise"
                      name="entreprise"
                      value={formData.entreprise}
                      onChange={handleChange}
                    />
                    <FormInput
                      label="Poste"
                      name="poste"
                      value={formData.poste}
                      onChange={handleChange}
                    />
                    <FormInput
                      label="Date début du contrat"
                      name="dateDebutContrat"
                      type="date"
                      value={formData.dateDebutContrat}
                      onChange={handleChange}
                    />
                    <FormInput
                      label="Rémunération (optionnel)"
                      name="remuneration"
                      type="number"
                      min="0"
                      value={formData.remuneration}
                      onChange={handleChange}
                      placeholder="Montant en FCFA"
                    />

                    <div>
                      <label htmlFor="saisie-salaire-mode" className="block text-sm font-medium mb-1">Salaire</label>
                      <div className="flex gap-2 mb-2" role="radiogroup" aria-labelledby="saisie-salaire-mode-label">
                        <span id="saisie-salaire-mode-label" className="sr-only">Mode de saisie du salaire</span>
                        <label htmlFor="saisie-salaire-mode-exact" className="flex items-center">
                          <input
                            id="saisie-salaire-mode-exact"
                            type="radio"
                            name="salaireMode"
                            value="exact"
                            checked={salaireMode === 'exact'}
                            onChange={(e) => setSalaireMode(e.target.value)}
                            className="mr-1"
                          />
                          <span className="text-sm">Montant</span>
                        </label>
                        <label htmlFor="saisie-salaire-mode-tranche" className="flex items-center">
                          <input
                            id="saisie-salaire-mode-tranche"
                            type="radio"
                            name="salaireMode"
                            value="tranche"
                            checked={salaireMode === 'tranche'}
                            onChange={(e) => setSalaireMode(e.target.value)}
                            className="mr-1"
                          />
                          <span className="text-sm">Tranche</span>
                        </label>
                      </div>
                      {salaireMode === 'exact' ? (
                        <FormInput
                          label="Montant salaire"
                          name="salaire"
                          type="number"
                          value={formData.salaire}
                          onChange={handleChange}
                          placeholder="Montant en FCFA"
                        />
                      ) : (
                        <FormSelect
                          label="Tranche salariale"
                          name="salaireTranche"
                          value={formData.salaireTranche}
                          onChange={handleChange}
                          options={config.tranchesSalariales || []}
                        />
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          )}

          {/* Suivi Administratif / Accompagnement */}
          {showInsertion && (
            <div className="border-l-4 border-amber-600 pl-4 bg-amber-50 rounded-r-lg py-4 pr-4">
              <h3 className="font-bold text-amber-800 mb-4 flex items-center">
                <Icon name="phone" size={20} className="mr-2" />
                Suivi Administratif / Accompagnement
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <FormSelect
                  label="Référent / Coach"
                  name="referent"
                  value={formData.referent}
                  onChange={handleChange}
                  options={config.referents || []}
                  onAddNew={() => openAddModal('referents')}
                  addLabel="+"
                  placeholder="Sélectionner un référent"
                />
                <FormInput
                  label="Dernière date de contact"
                  name="derniereDateContact"
                  type="date"
                  value={formData.derniereDateContact}
                  onChange={handleChange}
                />
                <FormSelect
                  label="État du dossier"
                  name="etatDossier"
                  value={formData.etatDossier}
                  onChange={handleChange}
                  options={config.etatsDossier || ['Complet', 'Pièces manquantes']}
                  onAddNew={() => openAddModal('etatsDossier')}
                  addLabel="+"
                />
              </div>
            </div>
          )}

          {/* Notes */}
          <div>
            <label htmlFor="saisie-notes" className="block text-sm font-medium mb-1">Notes / Observations</label>
            <textarea
              id="saisie-notes"
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              rows="3"
              autoComplete="off"
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              placeholder="Commentaires et observations..."
            />
          </div>

          {/* Boutons */}
          <div className="flex justify-end gap-3 pt-4 border-t">
            <button
              type="button"
              onClick={resetForm}
              className="flex items-center gap-2 px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
            >
              <Icon name="refresh" size={18} />
              <span>Réinitialiser</span>
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex items-center gap-2 px-6 py-2 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 disabled:opacity-50 transition-colors"
            >
              <Icon name={loading ? 'refresh' : 'save'} size={18} className={loading ? 'animate-spin' : ''} />
              <span>{loading ? 'Enregistrement...' : 'Enregistrer'}</span>
            </button>
          </div>
        </form>
      </div>

      {/* Modal d'ajout */}
      <Modal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        title={
          <span className="flex items-center">
            <Icon name="add" size={20} className="mr-2" />
            Ajouter {addModalType === 'statutsInsertion' ? 'statut' : addModalType}
          </span>
        }
        size="sm" zIndex={10001}
      >
        {addModalType === 'statutsInsertion' && (
          <div className="mb-4">
            <label htmlFor="add-modal-category" className="block text-sm font-medium mb-1">Catégorie</label>
            <select
              id="add-modal-category"
              name="category"
              value={addModalCategory}
              onChange={(e) => setAddModalCategory(e.target.value)}
              autoComplete="off"
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
            >
              <option value="positif">Positif</option>
              <option value="negatif">Négatif</option>
            </select>
          </div>
        )}
        <div className="mb-4">
          <label htmlFor="add-modal-value" className="block text-sm font-medium mb-1">Valeur</label>
          <input
            id="add-modal-value"
            name="value"
            type="text"
            value={addModalValue}
            onChange={(e) => setAddModalValue(e.target.value)}
            autoComplete="off"
            className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
            placeholder="Nouvel élément..."
          />
        </div>
        <div className="flex gap-3">
          <button
            onClick={() => setShowAddModal(false)}
            className="flex-1 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
          >
            Annuler
          </button>
          <button
            onClick={handleAddItem}
            className="flex-1 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
          >
            Ajouter
          </button>
        </div>
      </Modal>

      {/* Modale Import en Masse */}
      <Modal
        isOpen={showImportModal}
        onClose={() => {
          setShowImportModal(false);
          setImportFile(null);
          setImportData(null);
          setImportPreview([]);
        }}
        title={
          <span className="flex items-center">
            <Icon name="upload" size={20} className="mr-2" />
            Import en Masse
          </span>
        }
        size="lg"
      >
        <div className="space-y-4">
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r-lg text-sm">
            <p><strong>Formats :</strong> Excel (.xlsx), CSV (.csv)</p>
            <p><strong>Nom</strong> est la seule colonne obligatoire. Cochez ci-dessous les champs à importer : le tableau, le modèle et le formulaire s'adaptent.</p>
            <button type="button" onClick={downloadImportTemplate} className="text-blue-700 underline">
              Télécharger le modèle Excel
            </button>
          </div>

          <div className="border rounded-lg p-4 space-y-3">
            <p className="text-sm font-medium">Champs à importer</p>
            <label className="flex items-center gap-2 text-sm text-gray-500">
              <input type="checkbox" checked disabled readOnly />
              Nom (obligatoire)
            </label>
            <div>
              <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">Colonnes du fichier</p>
              <div className="flex flex-wrap gap-x-5 gap-y-2">
                {IMPORT_FILE_FIELDS.map(f => (
                  <label key={f.key} htmlFor={`import-field-${f.key}`} className="flex items-center gap-2 text-sm cursor-pointer">
                    <input
                      id={`import-field-${f.key}`}
                      type="checkbox"
                      checked={importFields.includes(f.key)}
                      onChange={() => toggleImportField(f.key)}
                    />
                    {f.label}
                  </label>
                ))}
              </div>
            </div>
            <div>
              <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">Informations de formation (identiques pour toutes les lignes)</p>
              <div className="flex flex-wrap gap-x-5 gap-y-2">
                {IMPORT_FORM_FIELDS.map(f => (
                  <label key={f.key} htmlFor={`import-field-${f.key}`} className="flex items-center gap-2 text-sm cursor-pointer">
                    <input
                      id={`import-field-${f.key}`}
                      type="checkbox"
                      checked={importFields.includes(f.key)}
                      onChange={() => toggleImportField(f.key)}
                    />
                    {f.label}
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div>
            <label htmlFor="massImportFile" className="block text-sm font-medium mb-1 sr-only">Fichier à importer</label>
            <div
              className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-red-400 cursor-pointer"
              onClick={() => document.getElementById('massImportFile').click()}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  document.getElementById('massImportFile').click();
                }
              }}
              aria-label="Sélectionner un fichier à importer"
            >
              <input
                type="file"
                id="massImportFile"
                name="massImportFile"
                accept=".xlsx,.xls,.csv"
                className="hidden"
                onChange={handleFileSelect}
                aria-label="Fichier à importer"
              />
              <Icon name="upload" size={48} className="mx-auto mb-3 text-gray-400" />
              <p className="text-gray-600">Cliquez pour sélectionner</p>
              {importFile && (
                <p className="text-sm text-gray-500 mt-2">{importFile.name}</p>
              )}
            </div>
          </div>

          {importPreview.length > 0 && (
            <div className="mb-4">
              <p className="font-medium text-green-600 mb-2">
                <span>{importData.length}</span> lignes détectées
              </p>
              <div className="max-h-40 overflow-y-auto bg-gray-50 rounded-lg border">
                <table className="w-full text-sm">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="p-2 text-left">Nom</th>
                      {selectedFileFields.map(f => (
                        <th key={f.key} className="p-2 text-center">{f.label}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {importPreview.map((row, idx) => (
                      <tr key={idx}>
                        <td className="p-2">{row.nom}</td>
                        {selectedFileFields.map(f => (
                          <td key={f.key} className="p-2 text-center">{row[f.key] || '-'}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div className="grid grid-cols-2 gap-4">
            {importFields.includes('typeFormation') && (
              <div>
                <label htmlFor="import-type-formation" className="block text-sm font-medium mb-1">Type Formation</label>
                <div className="flex gap-2">
                  <FormSelect
                    id="import-type-formation"
                    name="typeFormation"
                    label=""
                    value={importForm.typeFormation}
                    onChange={(e) => setImportForm(prev => ({ ...prev, typeFormation: e.target.value }))}
                    options={config?.typesFormation || []}
                    className="flex-1"
                  />
                  <button
                    type="button"
                    onClick={() => openAddModal('typesFormation', 'Ajouter type')}
                    className="px-3 py-2 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200"
                    aria-label="Ajouter un type de formation"
                  >
                    +
                  </button>
                </div>
              </div>
            )}
            {importFields.includes('filiere') && (
              <div>
                <label htmlFor="import-filiere" className="block text-sm font-medium mb-1">Référentiel</label>
                <div className="flex gap-2">
                  <FormSelect
                    id="import-filiere"
                    name="filiere"
                    label=""
                    value={importForm.filiere}
                    onChange={(e) => setImportForm(prev => ({ ...prev, filiere: e.target.value }))}
                    options={config?.filieres || []}
                    className="flex-1"
                  />
                  <button
                    type="button"
                    onClick={() => openAddModal('filieres', 'Ajouter filière')}
                    className="px-3 py-2 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200"
                    aria-label="Ajouter une filière"
                  >
                    +
                  </button>
                </div>
              </div>
            )}
            {importFields.includes('anneeFormation') && (
              <div>
                <label htmlFor="import-annee-formation" className="block text-sm font-medium mb-1">Année de formation</label>
                <input
                  id="import-annee-formation"
                  name="anneeFormation"
                  type="text"
                  value={importForm.anneeFormation}
                  onChange={(e) => setImportForm(prev => ({ ...prev, anneeFormation: e.target.value }))}
                  placeholder="Ex: 2025"
                  autoComplete="off"
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                />
              </div>
            )}
            {importFields.includes('dureeFormation') && (
              <div>
                <label htmlFor="import-duree-formation" className="block text-sm font-medium mb-1">Durée de formation</label>
                <input
                  id="import-duree-formation"
                  name="dureeFormation"
                  type="text"
                  value={importForm.dureeFormation}
                  onChange={(e) => setImportForm(prev => ({ ...prev, dureeFormation: e.target.value }))}
                  placeholder="Ex: 3 mois"
                  autoComplete="off"
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                />
              </div>
            )}
            {importFields.includes('dateDebut') && (
              <div>
                <label htmlFor="import-date-debut" className="block text-sm font-medium mb-1">Date Début</label>
                <input
                  id="import-date-debut"
                  name="dateDebut"
                  type="date"
                  value={importForm.dateDebut}
                  onChange={(e) => setImportForm(prev => ({ ...prev, dateDebut: e.target.value }))}
                  autoComplete="off"
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                />
              </div>
            )}
            {importFields.includes('dateFin') && (
              <div>
                <label htmlFor="import-date-fin" className="block text-sm font-medium mb-1">Date Fin</label>
                <input
                  id="import-date-fin"
                  name="dateFin"
                  type="date"
                  value={importForm.dateFin}
                  onChange={(e) => setImportForm(prev => ({ ...prev, dateFin: e.target.value }))}
                  autoComplete="off"
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                />
              </div>
            )}
            {importFields.includes('promotion') && (
              <div className="col-span-2">
                <label htmlFor="import-promotion" className="block text-sm font-medium mb-1">Promotion</label>
                <div className="flex gap-2">
                  <FormSelect
                    id="import-promotion"
                    name="promotion"
                    label=""
                    value={importForm.promotion}
                    onChange={(e) => setImportForm(prev => ({ ...prev, promotion: e.target.value }))}
                    options={config?.promotions || []}
                    className="flex-1"
                  />
                  <button
                    type="button"
                    onClick={() => openAddModal('promotions', 'Ajouter promotion')}
                    className="px-3 py-2 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200"
                    aria-label="Ajouter une promotion"
                  >
                    +
                  </button>
                </div>
              </div>
            )}
          </div>

          <button
            onClick={handleImport}
            disabled={!importFile || importData?.length === 0 || importLoading}
            className="w-full flex items-center justify-center gap-2 py-3 bg-red-600 text-white rounded-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed hover:bg-red-700 transition-colors"
          >
            <Icon name={importLoading ? 'refresh' : 'upload'} size={18} className={importLoading ? 'animate-spin' : ''} />
            <span>{importLoading ? 'Import en cours...' : 'Importer'}</span>
          </button>
        </div>
      </Modal>

      {/* Modale Mise à jour en masse des données d'insertion */}
      <Modal
        isOpen={showInsertionModal}
        onClose={closeInsertionModal}
        title={<span className="flex items-center">💼 Mise à jour en masse de l'insertion</span>}
        size="lg"
      >
        <div className="space-y-4">
          <div className="bg-green-50 border-l-4 border-green-500 p-4 rounded-r-lg text-sm space-y-1">
            <p><strong>Formats acceptés :</strong> Excel (.xlsx, .xls) et CSV (.csv).</p>
            <p><strong>Nom</strong> et <strong>Email ou Téléphone</strong> sont obligatoires pour identifier l'apprenant. Cochez les autres champs à utiliser, le modèle s'adapte.</p>
            <p className="text-gray-600">Seules les cellules renseignées sont mises à jour. Si une entreprise est indiquée sans statut, l'apprenant passe en « Inséré ».</p>
            <button type="button" onClick={downloadInsertionTemplate} className="text-green-700 underline">
              Télécharger le modèle Excel
            </button>
          </div>

          <div className="border rounded-lg p-4 space-y-3 bg-white">
            <p className="text-sm font-medium">Champs à utiliser</p>
            <label className="flex items-center gap-2 text-sm text-gray-500">
              <input type="checkbox" checked disabled readOnly />
              Nom (obligatoire)
            </label>
            <div>
              <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">Identification : email ou téléphone obligatoire (au moins un), prénom facultatif</p>
              <div className="flex flex-wrap gap-x-5 gap-y-2">
                {INSERTION_ID_FIELDS.map(f => (
                  <label key={f.key} htmlFor={`ins-field-${f.key}`} className="flex items-center gap-2 text-sm cursor-pointer">
                    <input
                      id={`ins-field-${f.key}`}
                      type="checkbox"
                      checked={insertionFields.includes(f.key)}
                      onChange={() => toggleInsertionField(f.key)}
                    />
                    {f.label}
                  </label>
                ))}
              </div>
            </div>
            <div>
              <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">Données d'insertion à mettre à jour</p>
              <div className="flex flex-wrap gap-x-5 gap-y-2">
                {INSERTION_UPDATE_FIELDS.map(f => (
                  <label key={f.key} htmlFor={`ins-field-${f.key}`} className="flex items-center gap-2 text-sm cursor-pointer">
                    <input
                      id={`ins-field-${f.key}`}
                      type="checkbox"
                      checked={insertionFields.includes(f.key)}
                      onChange={() => toggleInsertionField(f.key)}
                    />
                    {f.label}
                  </label>
                ))}
              </div>
            </div>
          </div>

          <input
            type="file"
            id="insertionImportFile"
            name="insertionImportFile"
            accept=".xlsx,.xls,.csv"
            aria-label="Fichier d'insertion"
            className="w-full text-sm"
            onChange={(e) => {
              const file = e.target.files[0] || null;
              setInsertionFile(file);
              setInsertionResult(null);
              if (file) sendInsertionFile(true, file); // aperçu automatique
            }}
          />

          {insertionResult && (
            <div className="text-sm space-y-2">
              <p className="font-medium text-green-700">
                {insertionResult.updated.length} apprenant(s) {insertionResult.dryRun ? 'seront mis à jour' : 'mis à jour'} sur {insertionResult.total} ligne(s)
              </p>
              {insertionResult.notFound.length > 0 && (
                <div className="bg-red-50 border border-red-200 rounded p-2">
                  <p className="font-medium text-red-700">{insertionResult.notFound.length} introuvable(s) :</p>
                  <p className="max-h-24 overflow-y-auto">
                    {insertionResult.notFound.map(n => `L${n.ligne} ${n.apprenant}`).join(' · ')}
                  </p>
                </div>
              )}
              {insertionResult.ambiguous.length > 0 && (
                <div className="bg-yellow-50 border border-yellow-200 rounded p-2">
                  <p className="font-medium text-yellow-700">{insertionResult.ambiguous.length} ambigu(s) (homonymes : cochez et renseignez l'email ou le téléphone) :</p>
                  <p className="max-h-24 overflow-y-auto">
                    {insertionResult.ambiguous.map(n => `L${n.ligne} ${n.apprenant}`).join(' · ')}
                  </p>
                </div>
              )}
              {insertionResult.ignored.length > 0 && (
                <div className="text-gray-500">
                  <p>{insertionResult.ignored.length} ligne(s) ignorée(s) :</p>
                  <p className="max-h-24 overflow-y-auto">
                    {insertionResult.ignored.map(n => `L${n.ligne} ${n.apprenant} (${n.raison})`).join(' · ')}
                  </p>
                </div>
              )}
              {insertionResult.updated.length > 0 && (
                <div className="max-h-40 overflow-y-auto bg-gray-50 rounded-lg border">
                  <table className="w-full">
                    <thead className="bg-gray-100">
                      <tr><th className="p-2 text-left">Ligne</th><th className="p-2 text-left">Apprenant</th><th className="p-2 text-left">Champs</th></tr>
                    </thead>
                    <tbody>
                      {insertionResult.updated.map(u => (
                        <tr key={u.ligne}>
                          <td className="p-2">{u.ligne}</td>
                          <td className="p-2">{u.apprenant}</td>
                          <td className="p-2">{u.champs.join(', ')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          {insertionLoading && !insertionResult && (
            <p className="text-sm text-gray-500">Analyse du fichier...</p>
          )}

          <button
            onClick={() => sendInsertionFile(false)}
            disabled={!insertionFile || insertionLoading || !insertionResult?.dryRun || insertionResult.updated.length === 0}
            className="w-full py-3 bg-green-600 text-white rounded-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed hover:bg-green-700"
          >
            {insertionLoading && insertionResult ? 'Mise à jour en cours...' : `Appliquer les mises à jour${insertionResult?.dryRun ? ` (${insertionResult.updated.length})` : ''}`}
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default Saisie;
